import { unref } from 'vue';
import { useCookieWrapper } from '@@/composables/useCookieWrapper';
import { useMetaStore } from '@@/stores/Meta';

export const useCompareFilter = (params = {}) => {
  const {
    activeListId,
    isFavorites = false,
    isPowderFinder = false,
  } = params;

  const metaStore = useMetaStore();
  let cookieName = 'compare-locations-filter';

  if (isFavorites) {
    cookieName = `favorite-locations-filter-${activeListId}`;
  }
  else if (isPowderFinder) {
    cookieName = 'explore-powder-finder';
  }

  const filterCookie = useCookieWrapper(cookieName);

  const populateFilter = (countryCodes, locationTypeIds) => {
    const filter = {
      locationTypes: metaStore.location_types.filter(({ id }) => locationTypeIds.includes(id)),
    };

    if (isPowderFinder) {
      filter.countries = metaStore.countries.filter(({ code }) => countryCodes.includes(code));
    }

    return filter;
  };

  const getFilterFromCookie = () => {
    if (!filterCookie.value) {
      return null;
    }

    return populateFilter(
      filterCookie.value.countries,
      filterCookie.value.locations,
    );
  };

  const getFilterFromQuery = () => {
    const { query } = useRoute();

    if (isPowderFinder && !query.countries && !query.locations) {
      return null;
    }

    if (!isPowderFinder && !query.locations) {
      return null;
    }

    try {
      const countryCodes = query.countries
        ? decodeURIComponent(query.countries).split(',')
        : [];
      const locationTypeIds = query.locations
        ? decodeURIComponent(query.locations)
            .split(',')
            .map((locationTypeId) => Number(locationTypeId))
        : [];

      return populateFilter(countryCodes, locationTypeIds);
    }
    catch (e) {
      return null;
    }
  };

  const setFilterCookie = () => {
    const filter2 = unref(filter);
    const value = { locations: filter2.locationTypes?.map(({ id }) => id) || [] };

    if (isPowderFinder) {
      value.countries = filter2.countries?.map(({ code }) => code) || [];
    }

    filterCookie.value = value;
  };

  const setFilterValue = (filter) => {
    const filterFromQuery = getFilterFromQuery();
    const filterFromCookie = getFilterFromCookie();

    if (filterFromQuery) {
      filter.value = filterFromQuery;
    }
    else if (filterFromCookie) {
      filter.value = filterFromCookie;
    }
  };

  const filter = isPowderFinder
    ? shallowRef({ countries: [], locationTypes: [] })
    : shallowRef({ locationTypes: [] });

  setFilterValue(filter);

  const isFilterSet = computed(() => {
    if (isPowderFinder) {
      return filter.value?.countries?.length > 0 || filter.value?.locationTypes?.length > 0;
    }

    return filter.value?.locationTypes?.length > 0;
  });

  return {
    filter: computed({
      get() {
        return filter.value;
      },
      set(newValue) {
        filter.value = newValue;
        setFilterCookie();
      },
    }),
    isFilterSet,
  };
};
